import React, { useEffect, useState } from 'react';
import Button from '../../../../../component/ui/Button';
import GeneralInvoice from './components/general';
import InvoiceFieldCustomisation from './components/invoiceFieldCustomisation';
import { toast } from 'react-toastify';
import { getInvoiceGeneral, UpdateInvoiceGeneral } from '../../../../../services/settings/sales';
import { stringToBool } from '../../../../../utils/utility';

export default function SettingsInvoices({ activeTab }) {
	const [invoiceTab, setInvoiceTab] = useState('General');
	const [isEdit, setIsEdit] = useState(false);
	const [isCreateForm, setIsCreateForm] = useState(false);
	const [loader, setLoader] = useState({
		isLoader: true,
		isSave: false,
		isGetData: true,
		isGetDataFieldCustomisation: true,
		isSaveFieldCustomisation: true,
	});
	const [customFieldError, setCustomFieldError] = useState(false);
	const [error, setError] = useState(false);
	const [customFieldForm, setCustomFieldForm] = useState({
		label_name: '',
		data_type: '',
		status: false,
		is_mandatory: false,
	});
	const [generalForm, setGeneralForm] = useState({});
	const [form, setForm] = useState({
		allow_editing_sales_invoice: false,
		allow_editing_sent_invoice: false,
		invoice_password: '',
		print_payment_qr_code: false,
		payment_notification_to_owner: false,
		payment_received_notification_to_customer: false,
		terms_and_conditions: '',
		customer_notes: '',
	});

	const getShowUndoChanged = () => {
		const hasChanged = JSON.stringify(generalForm) !== JSON.stringify(form);
		setIsEdit(hasChanged);
	};
	const handleGeneralInvoice = async () => {
		try {
			setLoader((prev) => ({
				...prev,
				isLoader: true,
				isSave: true,
			}));
			setIsEdit(false);
			const res = await UpdateInvoiceGeneral(form);
			if (res.success) {
				toast.success(res.message);
				getGeneralInvoices();
			} else {
				setIsEdit(true);
				toast.error(res.message);
			}
		} catch (error) {
			setIsEdit(true);
			console.log(error.message || 'Something went wrong!');
		} finally {
			setLoader((prev) => ({
				...prev,
				isLoader: false,
				isSave: false,
			}));
		}
	};

	const getGeneralInvoices = async () => {
		try {
			setLoader((prev) => ({
				...prev,
				isLoader: true,
				isGetData: true,
			}));

			const { invoice_settings } = await getInvoiceGeneral();
			var data = {
				allow_editing_sales_invoice:
					invoice_settings.allow_editing_sales_invoice !== null
						? stringToBool(invoice_settings.allow_editing_sales_invoice)
						: true,
				allow_editing_sent_invoice:
					invoice_settings.allow_editing_sent_invoice !== null &&
					invoice_settings.allow_editing_sent_invoice !== undefined
						? stringToBool(invoice_settings.allow_editing_sent_invoice)
						: false,
				invoice_password: invoice_settings.invoice_password || '',
				print_payment_qr_code:
					invoice_settings.print_payment_qr_code !== null
						? stringToBool(invoice_settings.print_payment_qr_code)
						: false,
				payment_notification_to_owner:
					invoice_settings.payment_notification_to_owner !== null
						? stringToBool(invoice_settings.payment_notification_to_owner)
						: false,
				payment_received_notification_to_customer:
					invoice_settings.payment_received_notification_to_customer !== null
						? stringToBool(invoice_settings.payment_received_notification_to_customer)
						: false,
				terms_and_conditions: invoice_settings.terms_and_conditions || '',
				customer_notes: invoice_settings.customer_notes || '',
			};
			setForm(data);
			setGeneralForm(data);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		} finally {
			setLoader((prev) => ({
				...prev,
				isLoader: false,
				isGetData: false,
			}));
		}
	};
	const handleCustomField = () => {};

	useEffect(() => {
		if (form) {
			getShowUndoChanged();
		}
	}, [form]);

	useEffect(() => {
		getGeneralInvoices();
	}, []);

	return (
		<div>
			<div style={{ backgroundColor: '#EDEDF7', position: 'sticky', top: 0, zIndex: 100 }}>
				<div className="d-flex py-3 px-2 justify-content-between align-items-center">
					<div className="fs-4 fw-semibold">{activeTab}</div>
					<div className="d-flex gap-3">
						{invoiceTab === 'Field Customisation' ? (
							<Button
								type="button"
								className="mt-0 btn-primary fs-5 fw-light add-pro py-1"
								button="Add New Custom Field"
								add
								onClick={() => setIsCreateForm(true)}
							/>
						) : (
							<>
								<Button
									type="button"
									className="btn-primary mt-0 fs-5 fw-light add-pro py-1 px-4"
									button="Save"
									disabled={!isEdit}
									onClick={() => handleGeneralInvoice()}
									loader={loader.isLoader && loader.isSave}
								/>
								{isEdit && (
									<Button
										type="button"
										className="btn-primary mt-0 fs-5 fw-light add-pro py-1 px-4"
										button="Undo Changed"
										onClick={() => {
											setIsEdit(false);
											getGeneralInvoices();
										}}
									/>
								)}
							</>
						)}
					</div>
				</div>
			</div>
			<div
				className="py-2 d-flex justify-content-between align-items-center"
				style={{
					backgroundColor: '#DADDEC',
					position: 'sticky',
					top: '52px',
					zIndex: 100,
					overflow: 'hidden',
				}}
			>
				<div>
					<ul className="nav mt-2">
						{['General', 'Field Customisation'].map((item, index) => (
							<li
								key={index}
								className="nav-item"
							>
								<div
									className={`tab-link ${invoiceTab === item ? 'active' : ''} d-flex align-items-center`}
									onClick={() => {
										setInvoiceTab(item);
										setIsCreateForm(false);
									}}
								>
									{item}
								</div>
							</li>
						))}
					</ul>
				</div>
				{isCreateForm && (
					<div className="d-flex gap-4 align-items-center px-2">
						<div
							className="bg-blue py-2 px-4 text-white fs-5 fw-light rounded-4 cursor-pointer"
							style={{ backgroundColor: '#0066ff' }}
							onClick={() => handleCustomField()}
						>
							Save
						</div>
						<div
							className="bg-blue py-2 px-4 text-white fs-5 fw-light rounded-4 cursor-pointer"
							style={{ backgroundColor: '#555B67' }}
							onClick={() => setIsCreateForm(false)}
						>
							Cancel
						</div>
					</div>
				)}
			</div>
			{invoiceTab === 'General' ? (
				<GeneralInvoice
					form={form}
					setForm={setForm}
					error={error}
					setError={setError}
					loader={loader}
				/>
			) : (
				<InvoiceFieldCustomisation
					isCreateForm={isCreateForm}
					setIsCreateForm={setIsCreateForm}
					setCustomFieldForm={setCustomFieldForm}
					customFieldForm={customFieldForm}
					setCustomFieldError={setCustomFieldError}
					customFieldError={customFieldError}
				/>
			)}
		</div>
	);
}
